import { render, staticRenderFns } from "./messageChange.vue?vue&type=template&id=b3f3e38e&scoped=true&"
import script from "./messageChange.vue?vue&type=script&lang=js&"
export * from "./messageChange.vue?vue&type=script&lang=js&"
import style0 from "./messageChange.vue?vue&type=style&index=0&id=b3f3e38e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f3e38e",
  null
  
)

export default component.exports